import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController, Events } from 'ionic-angular';
import { Database } from '../../providers/database';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { Http, Headers } from '@angular/http';
import firebase from 'firebase';

@Component({
  selector: 'page-event-cart',
  templateUrl: 'event-cart.html',
})
export class EventCart {

  client: any;
  dataCart: any;
  event: any;
  obs: any;
  payBlock: boolean = false;
  payLink: string = '';
  paymentData: any;
  total: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database,
    public auth: AuthData, public eventProvider: EventData, public http: Http, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public events: Events, public toastCtrl: ToastController) { }

  ngOnInit() {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.obs = this.eventProvider.getCatalogBadge(this.client, this.auth.getUser().uid).subscribe((data) => {
      this.dataCart = data;
      this.total = 0;
      this.dataCart.forEach((element: any) => {
        this.total += parseInt(element.price) * parseInt(element.quantity);
      });
    });

    if (this.event.paymentMethod) {
      this.db.getData('/Clients/' + this.client.url + '/PaymentMethods/' + this.event.paymentMethod)
        .then((result: any) => {
          this.paymentData = result.val();
        });
    }
    const userRef = firebase.database().ref(`/Clients/${this.client.id}/Users/${this.auth.getUser().uid}`);
    userRef.child('currentPayment').once('value').then(res => {
      if (res.val()) {
        userRef.child('pendentPayment').child(res.val()).once('value').then(data => {
          if (data.val()) {
            if (data.val().status === 'pendent') {
              this.payBlock = true;
              this.payLink = data.val().url;
            }
          }
        });
      } else {
        this.payLink = '';
        this.payBlock = false;
      }
    });
  }

  openPay() {
    window.open(this.payLink, '_blank');
  }

  customPayment() {
    this.alertCtrl.create({
      title: 'Proceso de pago',
      message: '¿Está seguro que desea continuar a la pasarela de pagos?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: () => {
            this.execPayment();
          },
          role: 'cancel'
        }
      ]
    }).present();
  }

  execPayment() {
    const loading = this.loadingCtrl.create({
      content: 'Procesando pago...'
    });
    loading.present();
    let items = [];
    let totalAmount = 0;
    this.dataCart.forEach(object => {
      totalAmount += object.price;
      const itemData = {
        currency_id: "COP",
        id: object.id,
        quantity: parseInt(object.quantity),
        title: object.name.es || object.name.en,
        unit_price: parseInt(object.price)
      }
      items.push(itemData);
    });
    const newKey = firebase.database().ref(`/Clients/${this.client.id}/Users/${this.auth.getUser().uid}` + `/pendentPayment`).push().key;
    const preferences = {
      items,
      external_reference: `/Clients/${this.client.id}/Users/${this.auth.getUser().uid}` +
      `/pendentPayment/${newKey}`
    }
    this.http.post('https://us-central1-rebus-mercadolibre.cloudfunctions.net/createPreference', preferences).subscribe(res => {
      const pendentPayment = {
        items,
        status: 'pendent',
        url: res.json().response.init_point
      }
      const newPaymentRef = firebase.database().ref(`/Clients/${this.client.id}/Users/${this.auth.getUser().uid}` + `/pendentPayment/${newKey}`);
      newPaymentRef.set(pendentPayment);
      firebase.database().ref(`/Clients/${this.client.id}/Users/${this.auth.getUser().uid}`).child('currentPayment').set(newKey);
      this.events.publish('payChanged', {
        client_id: this.client.id,
        user_id: this.auth.getUser().uid,
        db_reference: firebase.database().ref(preferences.external_reference)
      });

      window.open(res.json().response.init_point, '_blank');
      loading.dismiss().then(() => {
        this.toastCtrl.create({ message: 'El proceso de pago se encuentra pendiente, una vez haya sido finalizado serás notificado.', showCloseButton: true, position: 'middle' }).present();
        this.navCtrl.pop();
      });
    }, err => {
      loading.dismiss(() => {
        console.log('Error', err);
      });
    });
  }

  deleteItem(item, key) {
    this.db.deleteData('/Clients/' + this.client.url + '/___CartUsers/' + this.auth.getUser().uid + '/' + item.id)
      .catch(error => {
        console.log('error al eliminar')
      });
  }

  closeListener() {
    if (this.obs) {
      console.log('Se eliminan los observables de cart');
      this.obs.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-cart/event-cart.ts